import { Box, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get_auth_user_data, get_auth_user_tokens } from '../../redux/auth/auth.selectors';
import axiosInstance from '../../http-common';
import getErrorMessage, { logout_if_403 } from '../../util';
import RolesListSelectorBase from './RolesListSelectorBase';

const RolesListSelectorDataGrid = ({ params, users, setUsers }) => {

  const [selected_roles, set_selected_roles] = useState(params.row.roles_list || [params.row.role]);


  const current_user = useSelector(get_auth_user_data);
  const token_data = useSelector(get_auth_user_tokens);
  const current_user_id = current_user._id;

  const handleChangeRole = async (id, roles_list) => {
    try {
      await axiosInstance.patch(`/v1/user/role/${id}`, { roles_list }, {
        headers: {
          Authorization: token_data?.auth_token
        }
      });
      setUsers(prevUsers => prevUsers.map(user => user.id === id ? { ...user, roles_list, role: roles_list?.[0] } : user));
      set_selected_roles(roles_list);
    } catch (error) {
      logout_if_403(error);
      console.error(getErrorMessage(error));
    }
  };

  return (
    <RolesListSelectorBase
      disabled={params.row.id === current_user_id}
      change_handler={(event) => handleChangeRole(params.row.id, event.target.value)}
      selected_roles={selected_roles}
    />
  );
};

export default RolesListSelectorDataGrid;